import React, { useState, useEffect } from "react";
import { Route, useLocation, useHistory, Redirect } from "react-router-dom";

const ProtectedRoutes = (props) => {
	const url = window.location.pathname + window.location.search;

	const userToken = localStorage.getItem("token");
	if (userToken === null) {
		return <Redirect to={"/signin?redirect=" + url} />;
	}
	return <Route {...props} />;
};

export default ProtectedRoutes;
